import { render } from "./ProductFeaturedListPage.vue?vue&type=template&id=9845ba0e&scoped=true"
import script from "./ProductFeaturedListPage.vue?vue&type=script&lang=js"
export * from "./ProductFeaturedListPage.vue?vue&type=script&lang=js"

import "./ProductFeaturedListPage.vue?vue&type=style&index=0&id=9845ba0e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9845ba0e"

export default script